<!-- =========================================================================================
  File Name: EditDomain.vue
  Description: User Edit Page

========================================================================================== -->

<template>
  <div id="page-user-edit">

    <vs-alert color="danger" title="Course Not Found" :active.sync="errorOccurred">
      <span>Course record with id: {{ $route.params.courseId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'management-list-course'}"
                                        class="text-inherit underline">All Courses</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="courseData">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Details" icon-pack="feather" icon="icon-edit">
            <div class="tab-text">
              <course-details-tab class="mt-4" :data="courseData" v-on:update_courseData="update_courseData"/>
            </div>
          </vs-tab>
          <!---    <vs-tab label="Information" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
          <user-edit-tab-information class="mt-4" :data="user_data" />
            </div>
          </vs-tab> --->
          <!---  <vs-tab label="Social" icon-pack="feather" icon="icon-share-2">
          <div class="tab-text">
          <user-edit-tab-social class="mt-4" :data="user_data" />
            </div>
          </vs-tab> --->
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import CourseDetailsTab from './CourseDetailsTab.vue'


export default {
  components: {
    CourseDetailsTab
  },
  data () {
    return {
      courseData: null,
      errorOccurred: false,

      activeTab: 0
    }
  },
  methods: {
    loadCourseData () {
      this.$http.get(`courses/${this.$route.params.courseId}`)
        .then(response => {
          if (response.status === 200) {
            this.courseData = {}
            this.courseData.course_code = response.data.data.code
            this.courseData.course_id = response.data.data.id
            this.courseData.course_name = response.data.data.name
            this.courseData.course_description = response.data.data.description
            this.courseData.course_status = response.data.data.status
            this.courseData.course_thumbnail = response.data.data.thumbnail
            this.courseData.course_banner = response.data.data.banner
          }

        })
        .catch(error => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    update_courseData (data) {

      const pl = {
        name: data.course_name,
        code: data.course_code,
        description: data.course_description,
        thumbnail: data.course_thumbnail,
        banner: data.course_banner,
        status: data.course_status === undefined ? 'active' : data.course_status
      }

      if (pl.name === undefined) {
        return this.$vs.notify({
          title: 'Failed to update course',
          text: 'Please provide a Course Name',
          color: 'danger',
          position: 'top-right'
        })
      }


      this.$vs.loading()

      this.$http.post(`courses/${this.$route.params.courseId}`, pl)
        .then(response => {

          if (response.status === 200) {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Updated Course Successfully',
              text: `Course ${pl.name} has been updated.`,
              color: 'success',
              position: 'top-right'
            })
            return this.loadCourseData()
          }

        })
        .catch(exception => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while updating this course'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to update course',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    }
  },
  created () {
    this.loadCourseData(this.$route.params.courseId)
  }
}

</script>
